// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"d2ce7c14","777":"e4b75e47"}[chunkId] + ".chunk.js");